import swall from "sweetalert2";

const alert = {
  customConfirmation() {
    return swall
      .fire({
        title: "Apakah Anda yakin?",
        text: "Anda tidak akan bisa mengembalikan ini!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, hapus!",
        cancelButtonText: "Tidak, batalkan!",
        reverseButtons: true,
      })
      .then((result) => {
        // if (result.isConfirmed) {
        //   swall.fire("Dihapus!", "Data Anda telah dihapus.", "success");
        // } else if (result.dismiss === swall.DismissReason.cancel) {
        //   swall.fire("Dibatalkan", "Data Anda aman :)", "error");
        // }
        return result.isConfirmed;
      });
  },

  confirmation(callback, confirmationText = "") {
    swall
      .fire({
        text:
          confirmationText === ""
            ? "Apakah anda yakin ingin menghapus data ini?"
            : confirmationText,
        buttons: ["Tidak", "Iya"],
      })
      .then((willDelete) => {
        if (willDelete) {
          if (callback) callback();
        }
      });
  },

  confirmSwitch(callYes, callNo) {
    swall
      .fire({
        text: "Yakin Ingin Mengubah Data?",
        buttons: ["Tidak", "Iya"],
      })
      .then((willDelete) => {
        if (willDelete) {
          if (callYes) callYes();
        } else {
          if (callNo) callNo();
        }
      });
  },

  confirmation2(callback, confirmationText = "", stop) {
    swall
      .fire({
        text:
          confirmationText === ""
            ? "Apakah anda yakin ingin menghapus data ini?"
            : confirmationText,
        buttons: ["Tidak", "Iya"],
      })
      .then((result) => {
        if (result) {
          if (callback) {
            callback();
          } else {
            stop();
          }
        }
      });
  },

  success(successText = "", callback) {
    swall
      .fire({
        icon: "success",
        // title: 'Berhasil',
        text: successText === "" ? "Data berhasil disimpan!" : successText,
        button: true,
      })
      .then((result) => {
        if (result) {
          if (callback) callback();
        }
      });
  },

  warningStatus(successText = "", callback) {
    swall
      .fire({
        icon: "warning",
        text: successText === "" ? "Data berhasil disimpan!" : successText,
        button: true,
      })
      .then((result) => {
        if (result) {
          if (callback) callback();
        }
      });
  },

  successrubah(successText = "", callback) {
    swall
      .fire({
        icon: "success",
        text: successText === "" ? "Data berhasil diubah!" : successText,
        button: true,
      })
      .then((result) => {
        if (result) {
          if (callback) callback();
        }
      });
  },

  // successhapus(successText = "", callback) {
  //   swall
  //     .fire({
  //       icon: "success",
  //       text: successText === "" ? "Data berhasil dihapus!" : successText,
  //       button: true,
  //     })
  //     .then((result) => {
  //       if (result) {
  //         if (callback) callback();
  //       }
  //     });
  // },

  custom(status, successText = "", callback) {
    swall
      .fire({
        icon: status === 200 ? "success" : "warning",
        title: status === 200 ? "Berhasil" : "warning",
        text: successText === "" ? "" : successText,
        button: true,
      })
      .then((result) => {
        if (result) {
          if (callback) callback();
        }
      });
  },

  failed(failText = "", callback) {
    swall
      .fire({
        icon: "error",
        title: "Gagal",
        text:
          failText === ""
            ? "Terjadi Kesalahan, Silahkan Coba Kembali"
            : failText,
        button: true,
      })
      .then((result) => {
        if (result) {
          if (callback) callback();
        }
      });
  },

  warnings(failText = "", callback) {
    swall
      .fire({
        icon: "warning",
        title: "Perhatian !",
        text:
          failText === ""
            ? "Terjadi Kesalahan, Silahkan Coba Kembali"
            : failText,
        button: true,
      })
      .then((result) => {
        if (result) {
          if (callback) callback();
        }
      });
  },

  breaksession() {
    swall
      .fire({
        icon: "warning",
        text: "Sesi anda telah berakhir",
      })
      .then((result) => {
        if (result) {
          localStorage.clear();
          sessionStorage.clear();
          let baseURL = process.env.VUE_APP_PUBLIC_PATH
          window.location.href = baseURL == '/' ? baseURL + 'login' : baseURL + '/login';
        }
      });
  },
  setTimeout(failText = "", callback, router = null, redirectPath = "") {
    swall
      .fire({
        icon: "warning",
        title: "Perhatian !",
        text:
          failText === ""
            ? "Proses Sedang Berjalan. Untuk Konfirmasi, Silahkan Dicoba Beberapa Saat Lagi"
            : failText,
        button: true,
      })
      .then((result) => {
        if (result.isConfirmed) { 
          if (callback) callback();
          if (router && redirectPath) {
            router.push(redirectPath);
          }
        }
      });
  },
};

export default alert;
